import { render, staticRenderFns } from "./ArticleView.vue?vue&type=template&id=4e6372e6&"
import script from "./ArticleView.vue?vue&type=script&lang=js&"
export * from "./ArticleView.vue?vue&type=script&lang=js&"
import style0 from "./ArticleView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports